/* eslint-disable */
function debounceHelper(fn, delay, el) {
  let timeoutID = null
  return () => {
    clearTimeout(timeoutID)
    const args = arguments
    const that = this
    el.classList.add('debounce')
    if (el.closest('.debounce-wrapper')) {
      el.closest('.debounce-wrapper').classList.add('debounce')
    }
    timeoutID = setTimeout(() => {
      fn.apply(that, args)
      el.classList.remove('debounce')
      if (el.closest('.debounce-wrapper')) {
        el.closest('.debounce-wrapper').classList.remove('debounce')
      }
    }, delay)
  }
}

export default function debounce(el, binding) {
  if (binding.value !== binding.oldValue) {
    el.oninput = debounceHelper(() => {
      el.dispatchEvent(new Event('change'))
    }, parseInt(binding.value) || 500, el)
  }
}
